import { Routes } from '@angular/router';
import { AdminLayoutComponent } from './shared/components/layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './shared/components/layouts/auth-layout/auth-layout.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { AppComponent } from './app.component';
export const rootRouterConfig: Routes = [
  {
    path: '',
    redirectTo: 'auth/signin',
    pathMatch: 'full'
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule),
        data: { title: 'Dashboard', breadcrumb: 'DASHBOARD' }
      },
      {
        path: 'environmental',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/environmental/environmental.module').then(m => m.EnvironmentalModule),
        data: { title: 'Environmental', breadcrumb: 'environmental' }
      },
      {
        path: 'administration',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/administration/administration.module').then(m => m.AdministrationModule),
        data: { title: 'Administration', breadcrumb: 'Administration' }
      },
      {
        path: 'emissions',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/emissions/emissions.module').then(m => m.EmissionsModule),
        data: { title: 'Emissions', breadcrumb: 'Emissions' }
      },
      {
        path: 'security',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/security/security.module').then(m => m.SecurityModule),
        data: { title: 'Security', breadcrumb: 'Security' }
      },
    ]
  },
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'auth',
        loadChildren: () => import('./views/auth/auth.module').then(m => m.AuthModule),
        data: { title: 'Session' }
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule),
        data: { title: 'Dashboard', breadcrumb: 'Dashboard' }
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule),
        data: { title: 'Dashboard', breadcrumb: 'Dashboard' }
      },
      {
        path: 'emissions',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/environmental/emissions/emissions.module').then(m => m.EmissionsModule),
        data: { title: 'Emissions', breadcrumb: 'Emissions' }
      },
    ]
  },
  {
    path: '**',
    redirectTo: 'sessions/404'
  }
];

